<template>
  <div class="text-left">
    <v-row>
      <v-col cols="12">
        <h3 class="mt-15 mb-0">
          {{ $t("title.communicationData") }}
        </h3>
      </v-col>
    </v-row>

    <div class="required-label">
      <h5 class="mb-2">
        {{ $t("form.communication.congress_edition") }}
      </h5>
      <v-chip x-small outlined color="primary">
        {{ $t("form.mandatory") }}
      </v-chip>
    </div>
    <v-row>
      <v-col cols="12" lg="6" class="py-0">
        <v-select
          outlined
          v-model="publication.communication.congress_edition"
          :label="$t('form.communication.congress_edition')"
          :rules="rules.fieldRequired"
          :items="congressEditions"
          item-value="id"
          item-text="name"
          :readonly="disabledForm"
          @change="$emit('handle-change', 'communication', 'congress_edition')"
        >
        </v-select>
      </v-col>
      <v-col cols="12" lg="6" class="py-0">
        <v-checkbox
          v-model="publication.communication.presented_on_main"
          class="big"
          :label="$t('form.communication.mainConferenceDetail')"
          :readonly="disabledForm"
          @change="$emit('handle-change', 'communication', 'presented_on_main')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" class="py-0">
        <div class="required-label">
          <h5 class="mb-2">
            {{ $t("form.communication.date") }}
          </h5>
          <v-chip x-small outlined color="primary">
            {{ $t("form.mandatory") }}
          </v-chip>
        </div>
        <v-row>
          <v-col class="py-0">
            <v-menu
              v-model="menu_communication_date"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              :disabled="disabledForm"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  v-model="publication.communication.date"
                  :label="$t('form.communication.date')"
                  prepend-inner-icon="event"
                  readonly
                  v-on="on"
                  :rules="rules.fieldRequired"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="publication.communication.date"
                @input="menu_communication_date = false"
                :readonly="disabledForm"
                @change="$emit('handle-change', 'communication', 'date')"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" class="py-0">
        <div class="required-label">
          <h5 class="mb-2">
            {{ $t("form.communication.type") }}
          </h5>
          <v-chip x-small outlined color="primary">
            {{ $t("form.mandatory") }}
          </v-chip>
        </div>
        <v-row>
          <v-col class="py-0">
            <v-select
              outlined
              v-model="publication.communication.type"
              :label="$t('form.communication.type')"
              :rules="rules.fieldRequired"
              :items="communicationTypes"
              item-value="value"
              item-text="text"
              :readonly="disabledForm"
              @change="$emit('handle-change', 'communication', 'type')"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" class="py-0">
        <h5>
          {{ $t("form.communication.lecture_notes") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="publication.communication.lecture_notes"
              :label="$t('form.communication.lecture_notes')"
              outlined
              :readonly="disabledForm"
              :rules="rules.char_max_70"
              @change="$emit('handle-change', 'communication', 'lecture_notes')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" class="py-0">
        <h5>
          {{ $t("form.communication.prizes") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="publication.communication.prizes"
              :label="$t('form.communication.prizes')"
              outlined
              :readonly="disabledForm"
              :rules="rules.char_max_150"
              @change="$emit('handle-change', 'communication', 'prizes')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="required-label">
      <h5 class="mb-2">
        {{ $t("form.communication.feder_acknowledgements") }}
      </h5>
      <v-chip x-small outlined color="primary">
        {{ $t("form.mandatory") }}
      </v-chip>
    </div>
    <v-row>
      <v-col>
        <v-checkbox
          class="big"
          v-model="publication.communication.feder_acknowledgements"
          :label="$t('form.federAcknowledgementsDetail')"
          :readonly="disabledForm"
          :rules="rules.checkboxRequired"
          indeterminate
          @change="$emit('handle-change', 'communication', 'feder_acknowledgements')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import validationRules from "../../../mixins/validationRules";
import axios from "axios";
import publication_model from "../../../mixins/model_utils/publication_model";

export default {
  mixins: [validationRules, publication_model],
  name: "ModifyCommunication",
  props: {
    disabledForm: Boolean,
    publication: Object
  },
  data: () => ({
    menu_communication_date: false
  }),

  created() {
    this.getCommunicationTypes();
    this.getCongressEditions();
  }
};
</script>

<style scoped>
.required-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.required-label .v-chip {
  margin-left: 8px;
}
</style>
